module.exports = __webpack_public_path__ + "static/media/sfl_4.79a1ed06.jpg";